var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('router-link',{attrs:{"to":"/news"}},[_vm._v("News")]),_c('router-link',{attrs:{"to":"/ask"}},[_vm._v("Ask")]),_c('router-link',{attrs:{"to":"/jobs"}},[_vm._v("Jobs")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }